const Form = ({
  labelText,
  type,
  placeholder,
  handleChange,
  _name,
  _value,
  diff = false,
  showPassword = false,
  setShowPassword = null,
  needShowPassword,
}) => {
  return (
    <div className="input-item">
      <label htmlFor="" className="label-text">
        {labelText}
      </label>
      <input
        type={type}
        name={_name}
        className={"input-box"}
        placeholder={placeholder}
        onChange={handleChange}
        value={_value}
      />
      {needShowPassword && (
        <ShowPassword
          setShowPassword={setShowPassword}
          showPassword={showPassword}
        />
      )}
      {diff && <Terms />}
    </div>
  );
};

const ShowPassword = ({ showPassword, setShowPassword }) => {
  return showPassword ? (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={setShowPassword}
      className="password"
    >
      <path
        d="M2.62003 11.255L3.33503 10.545C2.55214 9.84206 1.93702 8.97234 1.53503 8C2.55003 5.465 5.35003 3.5 8.00003 3.5C8.68198 3.509 9.35775 3.63064 10 3.86L10.775 3.08C9.89636 2.70866 8.95388 2.51167 8.00003 2.5C6.37029 2.56129 4.79423 3.09878 3.46663 4.04604C2.13904 4.99331 1.11811 6.30882 0.530031 7.83C0.490315 7.93985 0.490315 8.06015 0.530031 8.17C0.974155 9.34851 1.69025 10.4055 2.62003 11.255Z"
        fill="#A9A9A5"
      />
      <path
        d="M6 7.865C6.03477 7.38586 6.24084 6.93524 6.58054 6.59554C6.92024 6.25584 7.37086 6.04977 7.85 6.015L8.755 5.105C8.24788 4.97147 7.71462 4.97321 7.20838 5.11003C6.70214 5.24685 6.24061 5.51399 5.8698 5.8848C5.49899 6.25561 5.23185 6.71714 5.09503 7.22338C4.95821 7.72962 4.95647 8.26288 5.09 8.77L6 7.865ZM15.47 7.83C14.8967 6.3366 13.899 5.04351 12.6 4.11L15 1.705L14.295 1L1 14.295L1.705 15L4.255 12.45C5.39194 13.117 6.68202 13.4787 8 13.5C9.62974 13.4387 11.2058 12.9012 12.5334 11.954C13.861 11.0067 14.8819 9.69118 15.47 8.17C15.5097 8.06015 15.5097 7.93985 15.47 7.83ZM10 8C9.99789 8.35005 9.90395 8.69342 9.72755 8.99578C9.55116 9.29815 9.29849 9.54892 8.9948 9.72303C8.69112 9.89714 8.34705 9.9885 7.997 9.98797C7.64694 9.98744 7.30315 9.89503 7 9.72L9.72 7C9.89975 7.30287 9.99634 7.64783 10 8ZM8 12.5C6.95103 12.4817 5.92195 12.2107 5 11.71L6.27 10.44C6.84767 10.8408 7.54777 11.026 8.24807 10.9632C8.94836 10.9005 9.60436 10.5937 10.1015 10.0965C10.5987 9.59937 10.9055 8.94336 10.9682 8.24307C11.031 7.54277 10.8458 6.84267 10.445 6.265L11.88 4.83C13.0273 5.61749 13.9245 6.71771 14.465 8C13.45 10.535 10.65 12.5 8 12.5Z"
        fill="#A9A9A5"
      />
    </svg>
  ) : (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={setShowPassword}
      className="password"
    >
      <path
        d="M15.47 7.83C14.882 6.30882 13.861 4.99331 12.5334 4.04604C11.2058 3.09878 9.62977 2.56129 8.00003 2.5C6.37029 2.56129 4.79423 3.09878 3.46663 4.04604C2.13904 4.99331 1.11811 6.30882 0.530031 7.83C0.490315 7.93985 0.490315 8.06015 0.530031 8.17C1.11811 9.69118 2.13904 11.0067 3.46663 11.954C4.79423 12.9012 6.37029 13.4387 8.00003 13.5C9.62977 13.4387 11.2058 12.9012 12.5334 11.954C13.861 11.0067 14.882 9.69118 15.47 8.17C15.5097 8.06015 15.5097 7.93985 15.47 7.83ZM8.00003 12.5C5.35003 12.5 2.55003 10.535 1.53503 8C2.55003 5.465 5.35003 3.5 8.00003 3.5C10.65 3.5 13.45 5.465 14.465 8C13.45 10.535 10.65 12.5 8.00003 12.5Z"
        fill="black"
      />
      <path
        d="M8 5C7.40666 5 6.82664 5.17595 6.33329 5.50559C5.83994 5.83524 5.45543 6.30377 5.22836 6.85195C5.0013 7.40013 4.94189 8.00333 5.05765 8.58527C5.1734 9.16721 5.45912 9.70176 5.87868 10.1213C6.29824 10.5409 6.83279 10.8266 7.41473 10.9424C7.99667 11.0581 8.59987 10.9987 9.14805 10.7716C9.69623 10.5446 10.1648 10.1601 10.4944 9.66671C10.8241 9.17336 11 8.59334 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79565 5 8 5ZM8 10C7.60444 10 7.21776 9.8827 6.88886 9.66294C6.55996 9.44318 6.30362 9.13082 6.15224 8.76537C6.00087 8.39991 5.96126 7.99778 6.03843 7.60982C6.1156 7.22186 6.30608 6.86549 6.58579 6.58579C6.86549 6.30608 7.22186 6.1156 7.60982 6.03843C7.99778 5.96126 8.39992 6.00087 8.76537 6.15224C9.13082 6.30362 9.44318 6.55996 9.66294 6.88886C9.8827 7.21776 10 7.60444 10 8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10Z"
        fill="black"
      />
    </svg>
  );
};

const Terms = () => {
  return (
    <div className="terms">
      <span className="condition">
        *Password should be at least 8 character
      </span>
    </div>
  );
};

export default Form;
